/**
 * The most domains one audience holds (NPJB-763). Mirrors the backend's
 * `MAX_COMPANY_DOMAINS`: a longer list is refused there, so it is refused here first.
 */
export const MAX_COMPANY_DOMAINS = 5000;

/**
 * NPJB-763 AC4 — turn typed or pasted text into the domains it names: one per line, or
 * comma separated (semicolons and spaces split too, as a pasted spreadsheet column brings
 * them). Lower-cased and de-duplicated, first seen first.
 *
 * Nothing else. The backend cleans each domain (scheme, `www.`, path) and is the only
 * judge of what a domain is — reducing `shop.acme.co.uk` needs the public suffix list,
 * which the browser does not have.
 */
export const splitDomains = (raw: string): string[] => {
  const seen = new Set<string>();
  for (const part of raw.split(/[\s,;]+/)) {
    const domain = part.trim().toLowerCase();
    if (domain) seen.add(domain);
  }
  return [...seen];
};

/** `1 account`, `1,234 accounts` — the count the field and the banner show. */
export const accountCount = (n: number): string =>
  `${n.toLocaleString()} ${n === 1 ? 'account' : 'accounts'}`;
